import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import {
  TextField,
  InputLabel,
  Input,
  Button,
  Autocomplete,
  TextareaAutosize,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableChartIcon from "@mui/icons-material/TableChart";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import CurrencyFormat from "react-currency-format";
import { makeStyles } from "@material-ui/core";
import DeleteIcon from "@mui/icons-material/Delete";
import { listAllRptItem } from "actions/FinanceReportActions";
import LoadingBox from "components/LoadingBox";
import MessageBox from "components/MessageBox";
import { RECORD_DELETE_RESET } from "constants/financeConstants";
import Notification from "components/Notification";
import ConfirmDialog from "components/ConfirmDialog";
import { ExportToExcel } from "components/ExportToExcel";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styles from "assets/jss/vivoleo-react-kit/views/componentsSections/addRecordScreenStyle";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const useStyles = makeStyles(styles);

export default function RptItemScreen(props) {
  const classes = useStyles();
  const fileName = "Reports" + new Date();

  const allRptItem = useSelector((state) => state.allRptItem);
  const { loading, records, error } = allRptItem;

  //const records = recordsList.Records;
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(listAllRptItem());
  }, [dispatch]);

  console.log("record:" + JSON.stringify(records));

  return (
    <div>
      <GridContainer justify="center" className={classes.contentText}>
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes.space30}> </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <center>
            <h3>All Report Items</h3>
          </center>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div className={classes.space30}> </div>
        </GridItem>
        <GridItem xs={12} sm={4} md={4}>
          <Button
            variant="outlined"
            className="medium"
            startIcon={
              <KeyboardBackspaceOutlinedIcon
                className={classes.vivoblueColor}
              />
            }
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </GridItem>
        <GridItem xs={12} sm={4} md={4}>
          <Button
            variant="outlined"
            className="medium"
            startIcon={<TableChartIcon className={classes.vivoblueColor} />}
            onClick={() => navigate("/listreportitems")}
          >
            All Report Items
          </Button>
        </GridItem>

        {loading ? (
          <LoadingBox></LoadingBox>
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <>
            <GridItem xs={12} sm={4} md={4}>
              <ExportToExcel apiData={records} fileName={fileName} />
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.space30}> </div>
            </GridItem>
            {records.map((x) => (
              <>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 400 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="left">
                          Item Name
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          Created By
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          From Date
                        </StyledTableCell>
                        <StyledTableCell align="left">To Date</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow>
                        <StyledTableCell align="left">
                          <Button
                            className="small"
                            onClick={() => navigate(`/rptitem/${x.itemname}`)}
                          >
                            {x.itemname}
                          </Button>
                        </StyledTableCell>
                        <StyledTableCell align="left">{x.user}</StyledTableCell>
                        <StyledTableCell align="left">
                          {x.fromdate}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {x.todate}
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                  <div className={classes.space30}> </div>
                  <Table sx={{ minWidth: 400 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="left">
                          Item Total Amount&nbsp;($CAD)
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          Item Total NET&nbsp;($CAD)
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          Item Total HST&nbsp;($CAD)
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <StyledTableRow key={x.itemname}>
                        <StyledTableCell align="left">
                          {x.itemamount}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {x.itemNET}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          {x.itemHST}
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableBody>
                  </Table>
                </TableContainer>

                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.space30}> </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <InputLabel htmlFor="itemdetail">Item Detail</InputLabel>
                </GridItem>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 400 }} aria-label="customized table">
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="left">Category</StyledTableCell>
                        <StyledTableCell align="left">
                          Amount&nbsp;($CAD)
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          NET Amounts&nbsp;($CAD)
                        </StyledTableCell>
                        <StyledTableCell align="left">
                          HST Amount&nbsp;($CAD)
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {x.subtotalcategory.map((y) => (
                        <StyledTableRow key={y.category}>
                          <StyledTableCell align="left">
                            {y.category}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {y.amount}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {y.NET}
                          </StyledTableCell>
                          <StyledTableCell align="left">
                            {y.HST}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.space30}> </div>
                  <InputLabel htmlFor="otherinfo">Other Info</InputLabel>
                  <TextareaAutosize
                    maxRows={4}
                    aria-label="maximum height"
                    placeholder="Maximum 4 rows"
                    defaultValue={x.otherinfo}
                    style={{ width: "100%" }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.space30}> </div>
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <button
                    type="button"
                    className="small"
                    onClick={() => navigate(`/records/${x._id}/edit`)}
                  >
                    Edit
                  </button>
                  {/* 
                                      <button
                    type="button"
                    className="small"
                    onClick={() => {
                      props.history.push(`/record/${x._id}`);
                    }}
                  >
                    Details
                  </button>
                    
                    
                    */}
                </GridItem>
              </>
            ))}
          </>
        )}
        <Notification notify={notify} setNotify={setNotify}></Notification>
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog}
        />
      </GridContainer>
    </div>
  );
}
